import React, {useState, useEffect, useRef, useContext} from 'react';
import './Ture.css';
// import Serviced_vehicles from './Components/serviced_vehicles.js';
// import { Toast } from 'primereact/toast';
// import Loading from '../../Loading/loading';
// import { AuthContext } from "../../Header/auth - context";
// import { useSelector } from 'react-redux';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import usePermission from '../../custom/usePermission';
import handlePrint from './naloziStrane/putniNalogStampa';
import handlePrintStampaOkreta from './naloziStrane/stampaOkretaStampa';
import { Toast } from 'primereact/toast';
import { TabMenu } from 'primereact/tabmenu';
import { Divider } from 'primereact/divider';
import { AutoComplete } from "primereact/autocomplete";
import { AuthContext } from "../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import TurePregled from './turePregled';
import PutniNalog from './putniNalog';
import AgencijskiNalog from './agencijskiNalog';
import StatusiNaloga from './StatusiNaloga';
import RadniNalog from './radniNalog';
import Dozvole from './dozvole';
import Blagajna from './blagajna';
import ObracunTure from './obracunTure';
import KretanjeVozila from './kretanjeVozila';
import CustomDropdown from '../../custom/customDropdown';
import { Button } from 'primereact/button';
import { openSessionModal } from '../../store/sessionModalSlice';
import { useSessionHelper } from '../../custom/sessionHelper';

/* Isti ekran opslužuje Ture i Agencijske naloge.

   Agencijski nalog je ista tura sa eksternim prevoznikom umesto našeg vozila —
   ima istu blagajnu, dnevnice, dozvole, kretanje i obračun. Kopija ovog fajla
   značila bi da se svaka buduća izmena radi dvaput, a razišli bi se već na
   prvoj koja se zaboravi.

   Razlikuje ih samo `agencijski`: po njemu se traži drugi spisak naloga (svoj
   brojčani niz, sufiks AN) i menja natpis trake za izbor. */
const Ture_unos = ({ agencijski = false }) => {

        const { sessionHelper } = useSessionHelper();
        const toast = useRef(null);
        const [activeIndex, setActiveIndex] = useState(0);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const eskaliran = useSelector(state => state.eskaliran)
        const role = useSelector(state => state.user_role)
        const { can } = usePermission();
  const { t } = useTranslation();
        const dispatch = useDispatch();
        const trip = useSelector(state => state.trip)
        const user = useSelector(state => state.user)
        const [tripsDB, setTripsDB] = useState(null)
        const [idTrip, setIdTrip] = useState(null)
        const [filteredTrip, setFilteredTrip] = useState([]);
        const [izabran, setIzabran] = useState(false)
        const [resetOnSubmit, setResetOnSubmit] = useState(false)
        const [sviPutni, setSviPutni] = useState(false);

    /* Tabovi se vode po KLJUCU, ne po rednom broju.

       Agencijski nalog ubacuje svoj tab ISPRED Putnog naloga, pa se svi redni
       brojevi iza njega pomeraju. Dok se renderovalo po `activeIndex == 3`,
       jedan ubacen tab bi tiho preusmerio Dozvole na Kretanje vozila — greska
       koja se ne vidi u kodu nego tek na ekranu. */
    const tabovi = [
        { kljuc: 'pregled', label: t('fakture.pregled') },
        /* Agencijski nalog NE menja Putni nalog — on ostaje isti kao na Turama
           (nase vozilo, vozac, kilometraza). Ovo je sloj iznad: ko vozi turu i
           po kojoj ceni. */
        ...(agencijski ? [{ kljuc: 'agencija', label: t('ture.agencijskiNalog') }] : []),
        { kljuc: 'putni', label: t('ture.putniNalog') },
        { kljuc: 'radni', label: t('ture.radniNalog') },
        { kljuc: 'kretanje', label: t('ture.kretanjeVozila') },
        { kljuc: 'dozvole', label: t('subnav.dozvole') },
        { kljuc: 'blagajna', label: t('subnav.blagajna') },
        { kljuc: 'obracun', label: t('ture.obracunTure') },
        /* Praćenje javnim linkom stoji na kraju, posle obračuna: tiče se cele
           ture i postoji i na Turama i na Agencijskim nalozima. */
        { kljuc: 'statusi', label: t('statusiNaloga.naslov') },
    ];
    const items = tabovi;
    const aktivan = tabovi[activeIndex]?.kljuc ?? 'pregled';
   
    const selectIdTripFUNC = async (e) => {

    // dispatch({
    //                         type: "TRIP",
    //                         value: idTrip.ID
    //                     });

    // console.log(idTrip)
    // setIdTrip(idTrip);
    // setIzabran(true);
        if(e.target.value == undefined) {
        setIzabran(false);
    } else {
        let idTrip = tripsDB.filter(x => x.Broj_putnog_naloga === e.target.value.Broj_putnog_naloga)

        let resultSession = await sessionHelper(user.userId,'PutniNalog', idTrip[0].ID)
        
            if(resultSession.zauzeto) {
                        dispatch(openSessionModal({
                          type: "SESSION_LOCK",
                          message: resultSession.message
                        }));
                        return
            }


        setIzabran(true);
        dispatch({
                            type: "TRIP",
                            value: idTrip[0].ID
                        });
        document.title = `TMS - ${idTrip[0].Broj_putnog_naloga}`
        setIdTrip(e.target.value);
    }  
    
    };

    const resetDispatchTrip = () => {
          dispatch({
                            type: "TRIP",
                            value: null
                        });
    }


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const handleDeleteTrip = () => {
            if(idTrip) {
            if(can('TURE', 'delete')) {
                   confirmDialog({
                    message: `Jel ste sigurni da želite pasivizirati putni nalog ${idTrip.Broj_putnog_naloga}?`,
                    acceptLabel: "Da",
                    rejectLabel: "Ne",
                    icon: "pi pi-info-circle",
                    acceptClassName: "p-button-danger",
                    accept: acceptDelete,
                    reject: rejectDelete,
                    });
            } else {
                toast.current.show({
                            severity: "warn",
                            summary: "Upozorenje!",
                            detail: "Nemate prava za brisanje putnog naloga!",
                            life: 3000,
                        });
            }
          }
    };
    const acceptDelete = async () => {
    
                
                if(izabran){
                
                              let requestOptions = {
                                method: "DELETE",
                                headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer " + auth.token,
                                },
                                body: JSON.stringify({
                                    id: idTrip.ID
                                }),
                            };
                    
                            await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/DeleteTrip", requestOptions)
                                .then(handleErrors)
                                .then((data) => {
    
                                    setIdTrip(null)
                                    setIzabran(null)
                                     dispatch({
                                    type: "TRIP",
                                    value: null
                                });
                                    
                                   toast.current.show({
                                    severity: "success",
                                    summary: "Uspešno pasiviziranje podataka putnog naloga!",
                                    life: 3000,
                                    });
                                })
                                .catch((error) => {
                                error.json().then((errorMessage) => {
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: errorMessage.message,
                                    life: 3000,
                                    });
                                    console.log(errorMessage);
                                });
                                });
                    } else {
                            toast.current.show({
                            severity: "warn",
                            summary: "Upozorenje!",
                            detail: "Nije moguće obrisati putni nalog, nije izabran!",
                            life: 3000,
                        });
                    }
               
    
      };
    
    const rejectDelete = () => {
        console.log("Odbijeno brsanje putnog naloga!");
      };

   useEffect(()=>{
           let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  sviPutni: sviPutni,
                                  /* Server vraća ili obične ili agencijske — nikad
                                     pomešano: dve vrste nemaju ni ista polja ni isti
                                     brojčani niz. */
                                  agencijski: agencijski ? 1 : 0
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/allTrips", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                if(data){
                                   setTripsDB(data) 
                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
      },[resetOnSubmit, sviPutni, agencijski])

  /* Posle unosa novog putnog naloga u store stigne samo njegov ID, pa dropdown
     "Izbor putnog naloga" ostaje prazan iako je nalog aktivan i forma popunjena.
     Ovde se iz sveže učitane liste nađe ceo objekat i postavi kao izabran —
     dropdown prikazuje Broj_putnog_naloga, a kod čita i obracunTure,
     pa nije dovoljno postaviti samo {ID}. */
  useEffect(()=>{
    if (trip == null) { setIdTrip(null); setIzabran(false); return; }
    if (!tripsDB || !tripsDB.length) return;
    if (idTrip && idTrip.ID === trip) return;      // već izabran

    const nadjen = tripsDB.find(x => x.ID === trip);
    if (nadjen) { setIdTrip(nadjen); setIzabran(true); }
      },[trip, tripsDB, idTrip])

      const isPage = (pregled) => {
        return pregled
      }
  useEffect(()=>{
    if(isPage){
        setIdTrip(null)
        setIzabran(false)
    }
  },[])

  useEffect(()=>{
    return () => {
        dispatch({ type: 'TURE_SEARCH_PUTNI', value: '' });
        dispatch({ type: 'TURE_SEARCH_RADNI', value: '' });
    }
  },[])

  const handlePrintServiceLog = () => {
    if(trip) {
          let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: trip
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/printServiceLog", requestOptions)
          .then(handleErrors)
          .then((data) => {

            if(data){
              handlePrint(data)
            } 
    
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
        } else {
           toast.current.show({
                severity: "warn",
                summary: "Upozorenje!",
                detail: "Niste izabrali putni nalog kako bi ga štampali!",
                life: 3000,
              });
        }
  }
  const handlePrintOkret = () => {
    if (!trip) {
      toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Niste izabrali putni nalog!", life: 3000 });
      return;
    }
    fetch(process.env.REACT_APP_BACKEND_URL + "/trip/printStampaOkreta", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
      body: JSON.stringify({ id_putni_nalog: trip }),
    })
      .then(handleErrors)
      .then((data) => { if (data) handlePrintStampaOkreta(data); })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
        }).catch(() => {});
      });
  }

  const handleSelect = () => {
    if (idTrip) {  // resetuj samo ako ima vrednost
        setIdTrip(null)
        setIzabran(false)
        resetDispatchTrip()
    }
   
  }
   return (
       <div>
        <Toast ref={toast} />
        <ConfirmDialog />
        <TabMenu id='modelTabMagacin' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ marginBottom: '0' }} model={items} />
              <div className="col-12"  style={{ borderBottom: '1px solid rgb(224, 221, 221)'}}>
                            
                              <div className={`gridHeader${izabran ? ' gridHeader-selected' : ''}`} style={{marginLeft:0}}>
                                        <h4>{t(agencijski ? 'ture.izborAgencijskog' : 'ture.izborPutnog')}:</h4>
                                                 <CustomDropdown
                                                 style={{ width: "20%", marginLeft: '1%' }}
                                                 id="id_putni_nalog"
                                                 name="id_putni_nalog"
                                                 value={idTrip}
                                                 options={tripsDB || []}
                                                 placeholder={t(agencijski ? 'ture.phAgencijskiNalog' : 'ture.phPutniNalog')}
                                                 optionLabel="Broj_putnog_naloga"
                                                 onChange={selectIdTripFUNC}
                                                 onFocus={handleSelect}
                                                                                                                            />

                            {izabran && <Button label={t('common.delete')} className="mt-3 zaposleniShift" onClick={handleDeleteTrip} />}
                            {/* Štampa putnog naloga ne zavisi od radnog naloga — radni nalog daje samo
                                relaciju, a vozilo, vozači, posada i dozvole stoje na putnom nalogu.
                                Ranije je ovde stajalo `idTrip.ImaRadni == 1`, pa se dugme nije ni videlo. */}
                            {idTrip ? <Button label={t('ture.putniNalog')} icon="pi pi-print" severity="secondary" className="mt-3 zaposleniShift" onClick={handlePrintServiceLog} /> : null}
                            {idTrip && idTrip.obracunTure == 149 ? <Button label={t('ture.stampaOkreta')} icon="pi pi-print" severity="secondary" className="mt-3 zaposleniShift" onClick={handlePrintOkret} /> : null}
                            </div>
                        </div>
           {aktivan === 'pregled' &&  <TurePregled agencijski={agencijski} resetOnSubmit={resetOnSubmit} setIzabran={setIzabran} setIdTrip={setIdTrip} idTrip={idTrip} isPage={isPage} tripsDB={tripsDB} setSviPutni={setSviPutni}/>}
           {aktivan === 'agencija' && <AgencijskiNalog />}
           {aktivan === 'putni' && <PutniNalog setResetOnSubmit={setResetOnSubmit} resetOnSubmit={resetOnSubmit}/>}
           {aktivan === 'radni' && <RadniNalog />}
           {aktivan === 'kretanje' && <KretanjeVozila/>}
           {aktivan === 'dozvole' && <Dozvole/>}
           {aktivan === 'blagajna' && <Blagajna/>}
           {aktivan === 'obracun' && <ObracunTure/>}
           {aktivan === 'statusi' && <StatusiNaloga agencijski={agencijski}/>}


       </div>
   )
}
export default Ture_unos;